module.exports = __webpack_public_path__ + "static/media/icons8-exportar-pdf.5639bb74.svg";